// InvestorStructure customer traffic has one canonical API family.
// Keep this centralized so individual panels cannot drift back to v2_5/v2_6.
export const INVESTOR_API_PREFIX = '/api/v2_chopart';

export const investorApi = (path) => `${INVESTOR_API_PREFIX}/${path}`;
